import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const MAX_TILE_WIDTH = '14.6rem'
const MIN_TILE_WIDTH = '12.8rem'

export const BodyTypeTileContainer = styled.div(
  ({ theme }) =>
    `
  width: fit-content;
  &:hover {
    p {
      color: ${theme.colors.purple.primary};
    }
  }
`
)

export const BodyTypeTileImageContainer = styled.div(
  ({ theme }) => `
  background-color: #F3F3F3;
  border-radius: ${theme.borderRadius.large}; 
  &:hover {
    border: 0.1rem solid ${theme.colors.purple.light4};
    box-shadow: 0.2rem 0.2rem 0.4rem 0 #3E41531A;
  }
  &:focus {
    border: 0.1rem solid ${theme.colors.blue.primary};   
  }
  `
)

export const BodyTypeTileImage = styled.img(
  ({ theme }) =>
    `
  width: ${MIN_TILE_WIDTH};
  height: 9.6rem;
  object-fit: cover;

  ${MEDIA_QUERIES(theme).medium} {
    width: ${MAX_TILE_WIDTH};
  }
`
)

export const CategoryTileContainer = styled.div(
  ({ theme }) =>
    `
  width: fit-content;
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.purple.dark1}
`
)

export const CategoryTileImage = styled.img(
  ({ theme }) =>
    `
  width: 30.6rem;
  height: 20rem;
  object-fit: cover;
  border-top-left-radius: ${theme.borderRadius.medium};
  border-top-right-radius: ${theme.borderRadius.medium};
`
)
